import React, { Component } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { blogsSection } from "../../portfolio.js";
import "./BlogPost.css";

// Wrapper to use hooks with class component
function BlogPostWrapper(props) {
  const { slug } = useParams();
  return <BlogPost {...props} slug={slug} />;
}

class BlogPost extends Component {
  render() {
    const theme = this.props.theme;
    const { slug } = this.props;

    // Find the blog post by slug
    const blog = blogsSection.blogs.find((b) => b.slug === slug);

    if (!blog) {
      return (
        <div className="blog-post-main">
          <Header theme={theme} />
          <div className="blog-post-container">
            <h1 style={{ color: theme.text }}>Blog post not found</h1>
            <Link to="/blogs" style={{ color: theme.secondaryText }}>
              ← Back to Blogs
            </Link>
          </div>
          <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        </div>
      );
    }

    return (
      <div className="blog-post-main">
        <Header theme={theme} />
        <div className="blog-post-container">
          <Link
            to="/blogs"
            className="back-link"
            style={{ color: theme.secondaryText }}
          >
            ← Back to Blogs
          </Link>

          {blog.coverImage && (
            <div className="blog-cover-image">
              <img src={blog.coverImage} alt={blog.title} />
            </div>
          )}

          <h1 className="blog-post-title" style={{ color: theme.text }}>
            {blog.title}
          </h1>

          <div className="blog-meta" style={{ color: theme.secondaryText }}>
            {blog.date && <span className="blog-date">{blog.date}</span>}
            {blog.readTime && (
              <span className="blog-read-time">· {blog.readTime}</span>
            )}
          </div>

          {blog.tags && (
            <div className="blog-tags">
              {blog.tags.map((tag, index) => (
                <span
                  key={index}
                  className="blog-tag"
                  style={{
                    backgroundColor: theme.highlight,
                    color: theme.text,
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          )}

          <div className="blog-content" style={{ color: theme.text }}>
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                // Custom rendering for images
                img: ({ node, ...props }) => (
                  <img
                    {...props}
                    className="blog-content-image"
                    alt={props.alt || ""}
                  />
                ),
                // Custom rendering for links
                a: ({ node, ...props }) => (
                  <a
                    {...props}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: theme.highlight }}
                  >
                    {props.children}
                  </a>
                ),
                // Custom rendering for code blocks
                pre: ({ node, children, ...props }) => (
                  <pre className="code-block" {...props}>
                    {children}
                  </pre>
                ),
                code: ({ node, className, children, ...props }) => {
                  const text = Array.isArray(children)
                    ? children.join("")
                    : String(children ?? "");
                  const isBlock =
                    (className && className.startsWith("language-")) ||
                    text.includes("\n");
                  return isBlock ? (
                    <code className={className || ""} {...props}>
                      {children}
                    </code>
                  ) : (
                    <code
                      className="inline-code"
                      style={{ backgroundColor: theme.highlight }}
                      {...props}
                    >
                      {children}
                    </code>
                  );
                },
                // Custom blockquote
                blockquote: ({ node, ...props }) => (
                  <blockquote
                    className="blog-blockquote"
                    style={{ borderColor: theme.highlight }}
                  >
                    {props.children}
                  </blockquote>
                ),
              }}
            >
              {blog.content}
            </ReactMarkdown>
          </div>
        </div>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default BlogPostWrapper;
